import BaseSvgIcon, { IconProps } from '@trustoo/components/ui/icon/BaseSvgIcon'

/**
 * Arrow back icon component.
 * Left-pointing arrow icon, commonly used for navigation.
 * If color is not provided, uses currentColor to inherit text color.
 */
const ArrowBackIcon = (props: IconProps) => {
    return (
        <BaseSvgIcon {...props}>
            <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
        </BaseSvgIcon>
    )
}

export default ArrowBackIcon
